import Components from 'views/Components/Components.jsx';
import CustomerDashboard from 'views/User/index.jsx';
import CustomerProfile from 'views/User/index.jsx';
// import CustomerProfile from '../views/User/Profile.jsx';
import CustomerAddress from 'views/User/index.jsx';
import AddressCreate from 'views/User/index.jsx';
import BookingList from 'views/User/index.jsx';
import FavouriteExpansion from 'views/User/index.jsx';
import ChangePassword from 'views/User/index.jsx';
import Inbox from 'views/User/index.jsx';
import EarningList from 'views/User/index.jsx';
import AddressUpdate from 'views/User/index.jsx';
import ServiceList from 'views/User/index.jsx';
import ProviderList from '../views/User/ProviderListing.jsx';
import ProviderDetail from '../views/User/ProviderDetail.jsx';
import CategoryService from '../views/Category/ServiceListing.jsx';
import MainSearch from '../views/Category/MainSearch.jsx';
import Signup from '../views/Signup/SignupStepper.jsx';
import BookingCreate from '../views/Booking/Create.jsx';
import BookingPayment from '../views/Booking/Payment.jsx';
import NotificationList from 'views/User/index.jsx';
import PromocodeList from 'views/User/index.jsx';
import ChatPanel from 'views/User/index.jsx';
import NotAllowed from '../views/NotAllowed.jsx';
import Maintainence from '../views/Maintainence.jsx';
import Page from '../views/Page/Detail.jsx';
import Contact from '../views/Page/Contact.jsx';
import SigninForm from '../views/LoginPage/SigninForm';
import RevenueList from 'views/User/index.jsx';
var indexRoutes = [
    //User Routes
    {
        path: '/user/dashboard',
        name: 'CustomerDashboard',
        component: CustomerDashboard
    },
    {
        path: '/user/profile',
        name: 'CustomerProfile',
        component: CustomerProfile
    },
    {
        path: '/user/address',
        name: 'CustomerAddress',
        component: CustomerAddress
    },
    {
        path: '/user/revenue',
        name: 'RevenueList',
        component: RevenueList
    },
    {
        path: '/address/create',
        name: 'AddressCreate',
        component: AddressCreate
    },
    // {
    //     path: '/provider-service/create',
    //     name: 'ProviderServiceCreate',
    //     component: ProviderServiceCreate
    // },
    {
        path: '/user/booking',
        name: 'BookingList',
        component: BookingList
    },
    {
        path: '/provider/service',
        name: 'ServiceList',
        component: ServiceList
    },

    {
        path: '/provider/booking',
        name: 'BookingList',
        component: BookingList
    },
    {
        path: '/provider/earning',
        name: 'EarningList',
        component: EarningList
    },
    {
        path: '/user/favourite',
        name: 'FavouriteList',
        component: FavouriteExpansion
    },

    {
        path: '/provider/list/:keyword/:city/:category',
        name: 'ProviderList',
        component: ProviderList
    },
    {
        path: '/provider/list/:service',
        name: 'ProviderList',
        component: ProviderList
    },
    {
        path: '/provider/category/:category',
        name: 'ProviderList',
        component: ProviderList
    },
    // {
    //     path: '/provider/all/:serviceId',
    //     name: 'ProviderList',
    //     component: ProviderList
    // },
    {
        path: '/provider/list/:city',
        name: 'ProviderList',
        component: ProviderList
    },
    {
        path: '/provider/list',
        name: 'ProviderList',
        component: ProviderList
    },
    {
        path: '/provider/detail/:providerId/:serviceId',
        name: 'ProviderDetail',
        component: ProviderDetail
    },

    {
        path: '/category/services',
        name: 'CategoryServices',
        component: CategoryService
    },
    {
        path: '/mainsearch',
        name: 'MainSearch',
        component: MainSearch
    },
    {
        path: '/signup',
        name: 'Signup',
        component: Signup
    },
    {
        path: '/book/service/:providerId/:serviceId/:itemId',
        name: 'BookingCreate',
        component: BookingCreate
    },
    {
        path: '/book/service/:providerId/:serviceId',
        name: 'BookingCreate',
        component: BookingCreate
    },
    {
        path: '/booking/payment/:bookingId',
        name: 'BookingPayment',
        component: BookingPayment
    },

    {
        path: '/address/update/:addressId',
        name: 'AddressUpdate',
        component: AddressUpdate
    },
    {
        path: '/user/chat',
        name: 'ChatPanel',
        component: ChatPanel
    },
    // {
    //     path: '/booking/detail/:bookingId',
    //     name: 'BookingDetail',
    //     component: BookingDetail
    // },
    {
        path: '/notification/list',
        name: 'NotificationList',
        component: NotificationList
    },
    {
        path: '/user/signin',
        name: 'SigninForm',
        component: SigninForm
    },

    {
        path: '/promocode/list',
        name: 'PromocodeList',
        component: PromocodeList
    },
    {
        path: '/user/changepassword',
        name: 'ChangePassword',
        component: ChangePassword
    },
    {
        path: '/user/inbox',
        name: 'Inbox',
        component: Inbox
    },

    {
        path: '/page/:slug',
        name: 'Page',
        component: Page
    },
    {
        path: '/contact-us',
        name: 'Contact',
        component: Contact
    },
    {
        path: '/403',
        name: 'NotAllowed',
        component: NotAllowed
    },
    {
        path: '/maintainence',
        name: 'Maintainence',
        component: Maintainence
    },

    { path: '/', name: 'Components', component: Components, exact: true }
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx